import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import Cart from '../Components/Cart';
import CheckoutPrivateCustomerInfo from '../Components/Checkout.PrivateCustomerInfo';
import CheckoutBusinessCustomerInfo from '../Components/Checkout.BusinessCustomerInfo';
import CheckoutDeliveryMethods from '../Components/Checkout.DeliveryMethods';
import CheckoutCampaignCode from '../Components/Checkout.CampaignCode';
import PaymentWidget from '../Components/Payments/PaymentWidget';
import InsiderRegistration from '../Components/Checkout.InsiderRegistration';
import { pushToDatalayer } from '../wooscripts/gtmEnchanced';

import constants from '../constants';

import {
    acceptTermsOfCondition,
    acceptNewsletter,
    chooseGender,
    setBusinessCustomer,
    setCampaignCode,
    setCountry,
    setDelivery,
    setPayment,
    setOrderNote,
    submit,
    verify,
    setCustomerDetails,
    setAlternativeAddress,
    setSignUp,
    setSelectedCompanyAddress,
    submitError,
    reloadPayment,
    setZip,
    submitCampaignCode,
    submitRequest,
    submitDone,
    getUnifaun,
    setGoodsMarking,
    updateGoodsMarking,
    makeBriqpayPurchaseDecision,
} from '../Actions/Checkout.action';
import {
    update as updateOrderRowQuantity,
    clear,
} from '../Actions/Cart.action';

import { translate } from '../Services/translation';
import { string, object, boolean, mixed } from 'yup';
import QuotationFormContainer from '../Containers/CasallPro/Quotation/QuotationForm.container';
import { setDataIfDifferent } from '../Services/LocalStorage.service';

const privateCustomerAdditionalDetailsSchema = object().shape({
    acceptTermsOfCondition: boolean()
        .required(translate(`validation.checkrequired`))
        .oneOf([true], translate(`validation.checkrequired`)),
    selectedDeliveryMethod: string().required(translate(`validation.required`)),
    deliveryCheckoutId: string().required(translate(`validation.required`)),
});

const privateCustomerAddressSchema = object().shape({
    email: string()
        .required(translate(`validation.required`))
        .email(translate(`validation.email`)),
    phoneNumber: string().required(translate(`validation.required`)),
    country: mixed()
        .required(translate(`validation.required`))
        .notOneOf([''], translate('validation.required')),
    city: string().required(translate(`validation.required`)),
    zipCode: string().required(translate(`validation.required`)),
    address: string().required(translate(`validation.required`)),
    lastName: string().required(translate(`validation.required`)),
    firstName: string().required(translate(`validation.required`)),
});

const privateCustomerAlternativeAddressSchema = object().shape({
    phoneNumber: string().required(translate(`validation.required`)),
    country: mixed()
        .required(translate(`validation.required`))
        .notOneOf([''], translate('validation.required')),
    city: string().required(translate(`validation.required`)),
    zipCode: string().required(translate(`validation.required`)),
    address: string().required(translate(`validation.required`)),
    lastName: string().required(translate(`validation.required`)),
    firstName: string().required(translate(`validation.required`)),
});

const businessCustomerDetailsSchema = object().shape({
    acceptTermsOfCondition: boolean()
        .required(translate(`validation.checkrequired`))
        .oneOf([true], translate(`validation.checkrequired`)),
    selectedDeliveryMethod: string().required(translate(`validation.required`)),
    email: string()
        .required(translate(`validation.required`))
        .email(translate(`validation.email`)),
    phoneNumber: string().required(translate(`validation.required`)),
    lastName: string().required(translate(`validation.required`)),
    firstName: string().required(translate(`validation.required`)),
    selectedCompanyAddressId: string().required(
        translate(`validation.required`),
    ),
    deliveryCheckoutId: string().required(translate(`validation.required`)),
});

const unifaunDeliverySetSchema = object().shape({
    unifaunOnChange: object().required(translate(`validation.required`)),
});

class CheckoutContainer extends Component {
    constructor(props) {
        super(props);
        this.child = React.createRef();
        this.state = {
            zip: null,
        };
        this.didQuotationGetSentModel = null;
    }

    subscribeToEvents() {
        window._briqpay.subscribe('addressupdate', data => {
            const { currentZip } = this.props.checkout.payload;
            if (data.shippingaddress.zip !== currentZip) {
                this.props.setZip(data.shippingaddress.zip);
            }
        });
        window._briqpay.subscribe('before-purchase', session => {
            unifaunDeliverySetSchema
                .validate(this.props.checkout.payload)
                .then(async () => {
                    await this.props.makeBriqpayPurchaseDecision(true);
                })
                .catch(async error => {
                    await this.props.makeBriqpayPurchaseDecision(false);
                    this.props.submitError(error);
                })
                .finally(() => {
                    window._briqpay.checkout.resumeDecision();
                });
        });
    }

    componentDidMount() {
        if (!this.props || !this.props.checkout) {
            return;
        }

        const { selectedPaymentMethod, selectedDeliveryMethod } =
            this.props.checkout.payload;
        selectedDeliveryMethod && this.props.setDelivery();
        selectedPaymentMethod && this.props.setPayment(selectedPaymentMethod);

        setTimeout(() => this.subscribeToEvents(), 1000);

        // fill default select value to the state
        const { customerDetails, alternativeAddress } =
            this.props.checkout.payload;
        (!customerDetails || !customerDetails.country) &&
            constants.countries &&
            constants.countries[0] &&
            this.props.onCustomerDetailsChange(
                'customerDetails',
                'country',
                constants.countries[0].value,
            );
        (!alternativeAddress || !alternativeAddress.country) &&
            constants.countries &&
            constants.countries[0] &&
            this.props.onCustomerDetailsChange(
                'alternativeAddress',
                'country',
                constants.countries[0].value,
            );
        this.sendGTMData('ecomCheckout', 1);
    }

    sendGTMData(event, step) {
        const { orderRows } = this.props.cart;
        let gtm = {
            event: event,
            step: step,
            orderRows: orderRows,
        };
        pushToDatalayer(gtm);
    }

    placeOrder() {
        const { payload } = this.props.checkout,
            {
                isBusinessCustomer,
                selectedCompanyAddressId,
                acceptTermsOfCondition,
                selectedPaymentMethod,
                selectedDeliveryMethod,
                unifaunOnChange,
            } = this.props.checkout.payload;

        const { deliveryCheckoutId } = unifaunOnChange;

        const notCustomerDetailFields = [
            'selectedCompanyAddressId',
            'selectedPaymentMethod',
            'selectedDeliveryMethod',
            'acceptTermsOfCondition',
            'deliveryCheckoutId',
        ];
        const onError = (error, addressPath = 'customerDetails') => {
            error.path =
                notCustomerDetailFields.indexOf(error.path) >= 0
                    ? error.path
                    : `${addressPath}-${error.path}`;
            this.props.submitError(error);
        };
        this.props.submitRequest();
        if (isBusinessCustomer) {
            businessCustomerDetailsSchema
                .validate({
                    ...payload.customerDetails,
                    selectedCompanyAddressId,
                    selectedPaymentMethod,
                    selectedDeliveryMethod,
                    acceptTermsOfCondition,
                    deliveryCheckoutId,
                })
                .then(() => {
                    this.sendGTMData('ecomCheckoutOption', 2);
                    this.props.submit();
                })
                .catch(onError);
        } else {
            const checkAltAddress =
                payload.alternativeAddress.showAlternativeAddress &&
                (payload.alternativeAddress.firstName ||
                    payload.alternativeAddress.lastName ||
                    payload.alternativeAddress.address ||
                    payload.alternativeAddress.zipCode ||
                    payload.alternativeAddress.city ||
                    payload.alternativeAddress.phoneNumber);

            privateCustomerAddressSchema
                .validate({
                    ...payload.customerDetails,
                })
                .then(() => {
                    payload.showAlternativeAddress =
                        payload.alternativeAddress.showAlternativeAddress;
                    if (checkAltAddress) {
                        privateCustomerAlternativeAddressSchema
                            .validate({
                                ...payload.alternativeAddress,
                            })
                            .then(() => {
                                privateCustomerAdditionalDetailsSchema
                                    .validate({
                                        selectedPaymentMethod,
                                        selectedDeliveryMethod,
                                        acceptTermsOfCondition,
                                        deliveryCheckoutId,
                                    })
                                    .then(() => {
                                        this.sendGTMData(
                                            'ecomCheckoutOption',
                                            2,
                                        );
                                        this.props.submit();
                                    })
                                    .catch(onError);
                            })
                            .catch(error => {
                                onError(error, 'alternativeAddress');
                            });
                    } else {
                        privateCustomerAdditionalDetailsSchema
                            .validate({
                                selectedPaymentMethod,
                                selectedDeliveryMethod,
                                acceptTermsOfCondition,
                            })
                            .then(() => {
                                this.sendGTMData('ecomCheckoutOption', 2);
                                this.props.submit();
                            })
                            .catch(onError);
                    }
                })
                .catch(onError);
        }
    }

    showQuotation(isCasallPro) {
        if (!isCasallPro) return false;

        const { cart } = this.props;
        const { quotationModel } = this.props.checkout.payload;

        if (quotationModel == undefined) return false;

        setDataIfDifferent('articleNumbersList', quotationModel.articleNumbers);

        if (!quotationModel.isLoggedIn) return true;

        if (quotationModel.anyProductMissingStock) return true;

        if (quotationModel.hasQuotationProductInCart) return true;

        return (
            quotationModel != undefined &&
            quotationModel.totalSumLimit != 0 &&
            cart.orderTotalDecimal >= quotationModel.totalSumLimit
        );
    }

    getQuotationResponse() {
        const { cart } = this.props;

        return cart.quotaionModel.response;
    }

    didQuotationGetSent() {
        if (!document.body.classList.contains('casall-pro')) return false;

        const { cart } = this.props;

        if (cart.quotaionModel == undefined) return false;

        return cart.quotaionModel.response != undefined;
    }

    render() {
        var breadcrumbs = document.getElementsByClassName(
            'breadcrumbs-container',
        )[0];
        if (!!breadcrumbs) breadcrumbs.remove();

        var didQuotationGetSent = this.didQuotationGetSent();
        if (this.didQuotationGetSentModel === null && didQuotationGetSent) {
            this.didQuotationGetSentModel = this.getQuotationResponse();
        }
        const { cart } = this.props;
        const isCasallB2B =
            document.body.classList.contains('casall-sport') && !isCasallPro;
        const unAuthenticatedB2B = !cart.isAuthenticated && isCasallB2B;

        let errorText =
            this.props.checkout.errors['login'] && unAuthenticatedB2B
                ? this.props.checkout.errors['login'].map(item => item)
                : translate(`checkout.cart.empty`);

        if (
            unAuthenticatedB2B ||
            !cart ||
            !cart.orderRows ||
            cart.orderRows.length < 1 ||
            this.didQuotationGetSentModel
        ) {
            return (
                <div className="row">
                    <div className="columns small-12">
                        <h1 className="checkout__title">
                            {this.didQuotationGetSentModel ? (
                                <div className={'quotation-form__response'}>
                                    {this.didQuotationGetSentModel.message}
                                </div>
                            ) : (
                                errorText
                            )}
                        </h1>
                    </div>
                </div>
            );
        }

        const { checkout } = this.props,
            { payload, errors = {} } = checkout,
            { paymentWidget, displayInsiderSignup, quotationModel } = payload;

        const isCasallPro = document.body.classList.contains('casall-pro');
        const showQuotation = this.showQuotation(isCasallPro);
        return (
            <Fragment>
                {(!paymentWidget || paymentWidget.isChangeable) &&
                    this.renderCartSection()}
                {/* {(!paymentWidget || paymentWidget.displayCustomerDetails) &&
                    this.renderCustomerDetailsSection()} */}
                {(!paymentWidget || paymentWidget.displayDeliveryMethods) &&
                    !showQuotation &&
                    this.renderDeliveryMethodsSection()}
                {displayInsiderSignup &&
                    !isCasallPro &&
                    this.renderNewsletterSection()}
                <div className="row">
                    <div className="columns">
                        <h3 className="checkout__section-title">
                            {translate('checkout.payment.title')}
                        </h3>
                        <div className="checkout__payment-wrapper">
                            {showQuotation ? (
                                <div
                                    id="quotation-form"
                                    className="quotation-form row"
                                >
                                    <QuotationFormContainer
                                        {...{
                                            isCustomerEmail:
                                                quotationModel.isCustomerEmail,
                                            logo: quotationModel.logo,
                                            articleNumbersList:
                                                quotationModel.articleNumbers,
                                            productDetails:
                                                quotationModel.productDetails,
                                            termsUrl: quotationModel.termsUrl,
                                            orderCarrier:
                                                quotationModel.orderCarrier,
                                            clearCart: this.props.clearCart,
                                        }}
                                    />
                                </div>
                            ) : (
                                <PaymentWidget
                                    {...paymentWidget}
                                    verify={this.props.verify}
                                />
                            )}
                        </div>
                    </div>
                </div>

                {/* {!paymentWidget && (
                    <Fragment>
                        <div className="row">
                            <h3 className="columns checkout__section-title">
                                {translate('checkout.order.title')}
                            </h3>
                        </div>

                        <section className="row checkout-info__container checkout-info__summary">
                            <CheckoutOrderNote
                                {...orderNote}
                                onChange={note => this.props.setOrderNote(note)}
                            />
                            <CheckoutOrderInfo cart={cart} />
                        </section>

                        <div className="row">
                          <div className="columns">
                            <input
                                className="checkout-info__checkbox-input"
                                type="checkbox"
                                id="acceptTermsOfCondition"
                                checked={payload.acceptTermsOfCondition}
                                onChange={event =>
                                    this.props.acceptTermsOfCondition(
                                        event.target.checked,
                                    )
                                }
                            />
                            <label
                                className="checkout-info__checkbox-label"
                                htmlFor="acceptTermsOfCondition"
                            >
                                {translate(
                                    'checkout.terms.acceptTermsOfCondition',
                                )}{' '}
                                <a
                                    className="checkout__link"
                                    href={payload.termsUrl}
                                    target="_blank"
                                >
                                    {translate('checkout.terms.link')}
                                </a>
                            </label>
                            {errors['acceptTermsOfCondition'] && (
                                <span
                                    className="form__validator--error form__validator--top-narrow"
                                    data-error-for="acceptTermsOfCondition"
                                >
                                    {errors['acceptTermsOfCondition'][0]}
                                </span>
                            )}
                            </div>
                        </div>

                        <div className="row">
                          <div className="columns">
                            {!authenticated &&
                            (isBusinessCustomer ||
                                checkoutMode ===
                                    constants.checkoutMode.companyCustomers) ? (
                                <button
                                    className="checkout__submit-button"
                                    onClick={() =>
                                        (location.href = payload.loginUrl)
                                    }
                                >
                                    {translate('checkout.login.to.placeorder')}
                                </button>
                            ) : (
                                <button
                                    type="submit"
                                    className="checkout__submit-button"
                                    disabled={checkout.isSubmitting}
                                    onClick={() => this.placeOrder()}
                                >
                                    {translate('checkout.placeorder')}
                                </button>
                            )}
                            </div>
                        </div>
                    </Fragment>
                )} */}

                <div className="row">
                    <div className="columns">
                        {errors &&
                            errors['general'] &&
                            errors['general'].map(item => (
                                <p className="checkout__validator--error">
                                    {item}
                                </p>
                            ))}
                    </div>
                </div>
            </Fragment>
        );
    }

    getZipCodeIfPayloadIsMissing(props) {
        const payload = props.checkout.payload;
        if (
            (payload.zipCode == undefined || payload.zipCode == '') &&
            payload.companyAddresses &&
            payload.companyAddresses.length > 0
        ) {
            const shippingAddress = payload.companyAddresses.find(
                x => x.addressType == 'Shipping',
            );
            if (
                shippingAddress != undefined &&
                (shippingAddress.zipCode != undefined ||
                    shippingAddress.zipCode != '')
            ) {
                return shippingAddress.zipCode;
            }
        }

        return payload.zipCode;
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.checkout.result &&
            this.props.checkout.result.redirectUrl
        ) {
            window.location = this.props.checkout.result.redirectUrl;
            return;
        }
        // When Klarna Widget is built in checkout, the delivery cost is not set. In order to include correct shipping costs, we trigger the widget to rebuild to calculate the correct price.
        //https://dev.azure.com/exsitec1/Casall%20Sport/_sprints/taskboard/Casall%20Sport%20Team/Casall%20Sport/Sprint%206?workitem=23144
        const { cart } = this.props;
        const { selectedPaymentMethod } = this.props.checkout.payload;
        if (
            cart.deliveryCost !== prevProps.cart.deliveryCost &&
            selectedPaymentMethod !==
                prevProps.checkout.payload.selectedPaymentMethod
        ) {
            this.props.setPayment(selectedPaymentMethod);
        }

        const { checkout } = this.props;
        const zipCode = this.getZipCodeIfPayloadIsMissing(this.props);

        if (!checkout.isSubmitting || !checkout.errors) {
            if (zipCode !== prevProps.checkout.payload.zipCode)
                if (this.state.zip !== zipCode) this.setState({ zip: zipCode });

            return;
        }

        const errorKeys = Object.keys(checkout.errors);
        if (!errorKeys || errorKeys.length < 1) {
            return;
        }

        const errorNode = document.querySelector(
            `[data-error-for="${errorKeys[0]}"]`,
        );
        if (!errorNode) {
            return;
        }

        const inputNode = errorNode.parentElement.querySelector('input');
        if (inputNode) {
            setTimeout(() => inputNode.focus(), 1000);
            inputNode.scrollIntoView({ behavior: 'smooth' });
        } else {
            errorNode.scrollIntoView({ behavior: 'smooth' });
        }
    }

    renderCartSection() {
        const { checkout, cart } = this.props,
            { errors = {}, payload } = checkout,
            { paymentWidget } = payload;
        const isCasallPro = document.body.classList.contains('casall-pro');
        const showQuotation = this.showQuotation(isCasallPro);

        return (
            <Fragment>
                <div className="row">
                    <div className="columns small-12">
                        <h1 className="checkout__title">
                            {translate('checkout.title')}
                        </h1>
                    </div>
                </div>
                {(checkout.payload.checkoutMessageTitle ||
                    checkout.payload.checkoutMessage) && (
                    <div className="checkout__checkout-message">
                        <b>{checkout.payload.checkoutMessageTitle}</b>
                        <p>{checkout.payload.checkoutMessage}</p>
                    </div>
                )}
                <div className="row">
                    <div className="columns">
                        <h3 className="checkout__section-title">
                            {translate('checkout.cart.title')}
                        </h3>
                    </div>
                </div>

                <div className="row">
                    <div className="columns">
                        {(!cart.hasQuotationProductInCart &&
                            cart.isAuthenticated &&
                            isCasallPro &&
                            errors &&
                            errors['cart']) ||
                        (!isCasallPro && errors && errors['cart'])
                            ? errors['cart'].map(item => (
                                  <p className="checkout__validator--error">
                                      {item}
                                  </p>
                              ))
                            : null}
                    </div>
                </div>

                <Cart
                    {...{
                        ...this.props.cart,
                        updateOrderRowQuantity:
                            this.props.updateOrderRowQuantity,
                        removeOrderRow: this.props.removeOrderRow,
                    }}
                />
                {!showQuotation && (
                    <div className="row checkout__summation-container">
                        <div className="columns">
                            <div className="checkout__summation-wrapper">
                                {!!cart.campaignCode && (
                                    <div className="row checkout__summation-row">
                                        <div className="columns">
                                            {translate(
                                                'checkout.usedcampaigncode',
                                            )}
                                        </div>
                                        <div className="columns text-right">
                                            {cart.campaignCode}
                                        </div>
                                    </div>
                                )}
                                {cart.orderDiscounts &&
                                    cart.orderDiscounts.length > 0 && (
                                        <div className="checkout__discount-wrapper">
                                            {cart.orderDiscounts.map(
                                                discount => (
                                                    <div
                                                        className="row checkout__discount-row"
                                                        key={discount.id}
                                                    >
                                                        <div className="columns checkout__discount-title">
                                                            {
                                                                discount.discountDescription
                                                            }
                                                        </div>
                                                        <div className="columns text-right checkout__discount-value">
                                                            -
                                                            {
                                                                discount.discountAmount
                                                            }
                                                        </div>
                                                    </div>
                                                ),
                                            )}
                                            <div className="row checkout__discount-row">
                                                <div className="columns checkout__discount-title">
                                                    {translate(
                                                        'checkout.order.discounttotal',
                                                    )}
                                                </div>
                                                <div className="columns text-right checkout__discount-value">
                                                    -{cart.totalDiscount}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                <div className="row checkout__summation-row">
                                    <div className="columns">
                                        {translate(
                                            'checkout.order.deliverycost',
                                        )}
                                    </div>
                                    <div className="columns text-right checkout__summation-row-value">
                                        {this.getCostOrFreeText(
                                            cart.deliveryCost,
                                        )}
                                    </div>
                                </div>
                                {isCasallPro &&
                                (cart.hasQuotationProductInCart ||
                                    !cart.isAuthenticated) ? (
                                    <></>
                                ) : (
                                    <div className="row checkout__summation-row totalsum">
                                        <div className="columns">
                                            {translate('checkout.cart.total')}
                                        </div>
                                        <div className="columns text-right checkout__summation-row-value">
                                            <p>{cart.grandTotal}</p>
                                            {(checkout.payload.channelType ===
                                                'B2B' ||
                                                checkout.payload
                                                    .isBusinessCustomer) && (
                                                <p>
                                                    {translate(
                                                        'checkout.order.grandTotal.exVat',
                                                    )}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                            {isCasallPro && (
                                <div>
                                    <h3 className="checkout__section-title">
                                        {translate(
                                            'checkout.goodsmarking.title',
                                        )}
                                    </h3>
                                    <div className="zip-code-input">
                                        <input
                                            type="text"
                                            id="customerDetails-goodsMarking"
                                            placeholder={translate(
                                                'checkout.delivery.goodsmarking.placeholder',
                                            )}
                                            className="form__input zip"
                                            onChange={e =>
                                                this.props.onGoodsMarkingChange(
                                                    'goodsMarking',
                                                    e.target.value,
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            )}
                            {(!paymentWidget || paymentWidget.isChangeable) &&
                                !isCasallPro &&
                                this.renderCampaignCodeSection()}
                        </div>
                    </div>
                )}
            </Fragment>
        );
    }

    renderCustomerDetailsSection() {
        const {
                checkout,
                onCustomerDetailsChange,
                onSignUpChange,
                setSelectedCompanyAddress,
                setCountry,
            } = this.props,
            { payload, errors = {} } = checkout,
            {
                companyName,
                authenticated,
                customerDetails,
                alternativeAddress,
                companyAddresses,
                selectedCompanyAddressId,
                isBusinessCustomer,
                signUp,
                checkoutMode,
            } = payload;
        const privateCustomerInfoComponent = (
            <CheckoutPrivateCustomerInfo
                {...{
                    customerDetails,
                    alternativeAddress,
                    authenticated,
                    onChange: onCustomerDetailsChange,
                    signUp,
                    onSignUpChange,
                    setCountry,
                    errors,
                }}
            />
        );
        const businessCustomerInfoComponent = (
            <CheckoutBusinessCustomerInfo
                {...{
                    customerDetails,
                    companyAddresses,
                    companyName,
                    authenticated,
                    selectedCompanyAddressId,
                    onChange: onCustomerDetailsChange,
                    setSelectedCompanyAddress,
                    errors,
                }}
            />
        );
        if (!authenticated) {
            return (
                <Fragment>
                    <div className="row">
                        <div className="columns">
                            <h3 className="checkout__section-title">
                                {translate('checkout.customerinfo.title')}
                            </h3>
                            <Fragment>
                                <label className="checkout__text--in-line">
                                    {translate(
                                        'checkout.customerinfo.existingcustomer',
                                    )}
                                </label>
                                &nbsp;
                                <a
                                    href={payload.loginUrl}
                                    className="checkout__link"
                                >
                                    {translate(
                                        'checkout.customerinfo.clicktologin',
                                    )}
                                </a>
                                &nbsp;
                                {!isBusinessCustomer &&
                                    checkoutMode ===
                                        constants.checkoutMode.both && (
                                        <a
                                            onClick={() =>
                                                this.props.setBusinessCustomer(
                                                    true,
                                                )
                                            }
                                            className="checkout__link"
                                        >
                                            {translate(
                                                'checkout.customerinfo.businesscustomer',
                                            )}
                                        </a>
                                    )}
                            </Fragment>
                            {isBusinessCustomer &&
                                checkoutMode ===
                                    constants.checkoutMode.both && (
                                    <a
                                        onClick={() =>
                                            this.props.setBusinessCustomer(
                                                false,
                                            )
                                        }
                                        className="checkout__link"
                                    >
                                        {translate(
                                            'checkout.customerinfo.privatecustomer',
                                        )}
                                    </a>
                                )}
                        </div>
                    </div>
                    {!isBusinessCustomer &&
                        checkoutMode !==
                            constants.checkoutMode.companyCustomers &&
                        privateCustomerInfoComponent}
                    {(isBusinessCustomer ||
                        checkoutMode ===
                            constants.checkoutMode.companyCustomers) &&
                        businessCustomerInfoComponent}
                </Fragment>
            );
        }
        if (isBusinessCustomer) {
            return (
                <Fragment>
                    <div className="row">
                        <div className="columns">
                            <h3 className="checkout__section-title">
                                {translate('checkout.customerinfo.title')}
                            </h3>
                        </div>
                    </div>
                    {authenticated && businessCustomerInfoComponent}
                </Fragment>
            );
        }

        return (
            <Fragment>
                <div className="row">
                    <div className="columns">
                        <h3 className="checkout__section-title">
                            {translate('checkout.customerinfo.title')}
                        </h3>
                    </div>
                </div>
                {privateCustomerInfoComponent}
            </Fragment>
        );
    }

    getCostOrFreeText(deliveryCost) {
        return !parseFloat(deliveryCost.replace(/[^\d.,-]/g, ''))
            ? translate('checkout.order.free')
            : deliveryCost;
    }

    onZipChange(e) {
        this.setState({ zip: e.target.value });
    }

    renderDeliveryMethodsSection() {
        //unifaun extended
        const { checkout } = this.props,
            { payload, errors = {} } = checkout,
            { customerDetails, zipCode } = payload;

        const showZipInput =
            true && !this.showQuotation() ? (
                <div className="row delivery-input-container">
                    <div className="columns input-group">
                        <h3 className="checkout__section-title">
                            {translate('checkout.delivery.title')}
                        </h3>
                        <div className="zip-code-input">
                            <input
                                type="text"
                                id="zipInput"
                                placeholder={translate(
                                    'checkout.delivery.zipcode.placeholder',
                                )}
                                className="form__input zip"
                                maxLength="5"
                                value={this.state.zip}
                                onChange={e => this.onZipChange(e)}
                            />
                            <button
                                onClick={() => {
                                    const nextValue =
                                        document.getElementById(
                                            'zipInput',
                                        ).value;
                                    if (nextValue && nextValue !== '') {
                                        this.props.setZip(nextValue);
                                    }
                                }}
                            >
                                {translate('checkout.zipcodesearch')}
                            </button>
                        </div>
                        {errors['unifaunOnChange'] && (
                            <span className="form__validator--error form__validator--top-narrow">
                                {errors['unifaunOnChange'][0]}
                            </span>
                        )}
                    </div>
                </div>
            ) : (
                <h3 className="checkout__section-title">
                    {translate('checkout.delivery.title')}
                </h3>
            );
        return (
            <Fragment>
                {showZipInput}
                <CheckoutDeliveryMethods
                    {...this.props}
                    zip={zipCode}
                    country={customerDetails.country}
                    onChange={this.props.setDelivery}
                />
                {errors['selectedDeliveryMethod'] && (
                    <span className="form__validator--error form__validator--top-narrow">
                        {errors['selectedDeliveryMethod'][0]}
                    </span>
                )}
            </Fragment>
        );
    }

    renderCampaignCodeSection() {
        const { checkout } = this.props,
            { errors = {} } = checkout;

        return (
            <>
                <div className="row columns campaign-holder">
                    <CheckoutCampaignCode
                        errors={errors}
                        onCampaignCodeChange={this.props.setCampaignCode}
                        onSubmitCampaignCode={this.props.submitCampaignCode}
                    />
                </div>
            </>
        );
    }

    renderNewsletterSection() {
        return <InsiderRegistration {...this.props} />;
    }
}

const mapStateToProps = state => {
    const { cart, checkout } = state;
    return {
        cart,
        checkout,
    };
};

const mapDispatchToProps = dispatch => {
    const debouncedReloadPayment = debounce(
        dispatch => dispatch(reloadPayment()),
        750,
    );
    const debouncedReloadDelivery = debounce(dispatch => {
        dispatch(setZip(null));
    }, 750);
    const debouncedGoodsMarking = debounce(dispatch => {
        dispatch(updateGoodsMarking());
    }, 500);

    return {
        getDeliveryConfig: (widget, settings) =>
            dispatch(getUnifaun(widget, settings)), //unifaun extended
        submit: () => dispatch(submit()),
        setBusinessCustomer: value => dispatch(setBusinessCustomer(value)),
        setCampaignCode: code => dispatch(setCampaignCode(code)),
        setCountry: systemId => dispatch(setCountry(systemId)),
        setDelivery: systemId => dispatch(setDelivery(systemId)),
        setZip: zip => dispatch(setZip(zip)),
        setPayment: systemId => dispatch(setPayment(systemId)),
        setOrderNote: note => dispatch(setOrderNote(note)),
        acceptTermsOfCondition: accept =>
            dispatch(acceptTermsOfCondition(accept)),
        acceptNewsletter: accept => dispatch(acceptNewsletter(accept)),
        chooseGender: (field, value) => dispatch(chooseGender(field, value)),
        verify: (url, orderId, payload) =>
            dispatch(verify(url, orderId, payload)),
        onSignUpChange: signUp => dispatch(setSignUp(signUp)),
        submitCampaignCode: () => dispatch(submitCampaignCode()),
        submitRequest: () => dispatch(submitRequest()),
        makeBriqpayPurchaseDecision: decision =>
            dispatch(makeBriqpayPurchaseDecision(decision)),
        submitError: error => {
            dispatch(submitError(error));
            dispatch(submitDone(null));
        },
        setSelectedCompanyAddress: (companyAddressId, country) => {
            dispatch(setSelectedCompanyAddress(companyAddressId));
            dispatch(setCountry(country));
        },
        onCustomerDetailsChange: (stateKey, propName, value) => {
            switch (stateKey) {
                case 'customerDetails':
                    dispatch(setCustomerDetails(propName, value));
                    break;
                case 'alternativeAddress':
                    dispatch(setAlternativeAddress(propName, value));
                    break;
            }
        },

        updateOrderRowQuantity: (rowId, quantity) =>
            dispatch(updateOrderRowQuantity(rowId, quantity)).then(() => {
                debouncedReloadPayment(dispatch);
                debouncedReloadDelivery(dispatch);
            }),

        removeOrderRow: rowId =>
            dispatch(updateOrderRowQuantity(rowId, 0)).then(() =>
                dispatch(reloadPayment()),
            ),
        clearCart: quotationModel =>
            dispatch(clear(quotationModel)).then(() =>
                dispatch(reloadPayment()),
            ),
        onGoodsMarkingChange: (propName, value) => {
            dispatch(setGoodsMarking(propName, value));
            debouncedGoodsMarking(dispatch);
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutContainer);
